// extracted by mini-css-extract-plugin
export default {"form":"FormItem_form__EEfTP"};